// src/contexts/AppProvider.tsx - Main app provider that combines all contexts
import React, { ReactNode } from 'react';
import { ThemeProvider } from './ThemeContext';
import { NavigationProvider } from './NavigationContext';

interface AppProviderProps {
  children: ReactNode;
}

export const AppProvider: React.FC<AppProviderProps> = ({ children }) => {
  return (
    <ThemeProvider>
      <NavigationProvider>
        {children}
      </NavigationProvider>
    </ThemeProvider>
  );
};
